import React, { memo } from 'react'
import { Grid } from '@material-ui/core'
import EditableHTML from '@v4/components/common/EditableHTML'
import PropTypes from 'prop-types'
import EditableContainer from '@v4/components/common/EditableContainer'
import SortHandler from '@v4/components/common/SortHandler'
import VideoBlock from '../../../../components/VideoBlock'
import { useContent } from './Content.hooks'

const Content = props => {
	const [
		{ classes, isMobile, direction, text, textConfig, video, extraShortcuts, textEditable, textKey },
		{ handleTextClick, handleTextChange },
	] = useContent(props)

	return (
		<Grid container justify="center" className={classes.root}>
			<SortHandler key={isMobile ? 'mobile' : 'desktop'} direction={direction}>
				<EditableContainer
					visible={!!text}
					fieldConfig={textConfig}
					onAdd={handleTextChange}
					editable={textEditable}
					wrapper={({ children }) => (
						<Grid item xs={12} sm={10} md={8} className={classes.textContainer}>
							{children}
						</Grid>
					)}
				>
					<EditableHTML
						key={textKey}
						html={text}
						className={classes.text}
						onClick={handleTextClick}
						extraShortcuts={extraShortcuts}
						editable={textEditable}
						onChange={handleTextChange}
					/>
				</EditableContainer>
				<Grid item xs={12} sm={10} md={8} className={classes.videoContainer}>
					<VideoBlock className={classes.video} value={video} />
				</Grid>
			</SortHandler>
		</Grid>
	)
}

Content.propTypes = {
	text: PropTypes.string,
	textConfig: PropTypes.object,
	video: PropTypes.string,
	extraShortcuts: PropTypes.objectOf(PropTypes.string),
	onTextClick: PropTypes.func,
	classes: PropTypes.shape({
		root: PropTypes.string,
		textContainer: PropTypes.string,
		text: PropTypes.string,
		videoContainer: PropTypes.string,
		video: PropTypes.string,
	}),
	textEditable: PropTypes.bool,
	onTextChange: PropTypes.func,
	textKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mobileAlignment: PropTypes.string,
	videoPosition: PropTypes.string,
}
Content.defaultProps = {
	classes: undefined,
}

export default memo(Content)
